import { toDinero } from 'utilities/currency';

const includedTaxCalculation = (amount, taxRate) => {
  const dinero = toDinero(amount);
  const principal = dinero.divide(1 + taxRate);
  return {
    principal,
    tax: dinero.subtract(principal),
  };
};

const taxGroupingByLabel = (taxBreakdown) => {
  return taxBreakdown.reduce((acc, taxBlob) => {
    return {
      ...acc,
      [taxBlob.label]: {
        ...taxBlob,
        amount: toDinero(acc[taxBlob.label]?.amount || 0)
          .add(toDinero(taxBlob.amount))
          .toUnit(),
      },
    };
  }, {});
};

// this enforces max precision of 3 decimals or less
// ex: 7%, 7.5%, 7.325%
const toPercentageString = (amount) => {
  return `${Number.parseFloat((amount * 100).toFixed(3)).toString()}%`;
};

export { includedTaxCalculation, toPercentageString, taxGroupingByLabel };
